export const STORY_CONTENT = {
  chapters: {
    chapter1: {
      scenes: {
        enterWoods: {
          location: 'windingPath',
          beats: {
            introduction: {
              lines: [
                { type: 'narration', text: "The dense Minnesota woods stretch endlessly before Oliver, their ancient trees beckoning with whispered promises of adventure." },
                { type: 'dialog', speaker: 'oliver', variation: 'thinking', text: "I've always wondered what secrets these woods hold..." },
                { type: 'narration', text: "A gentle breeze rustles through the leaves, almost like a welcoming gesture." },
                { type: 'dialog', speaker: 'oliver', variation: 'neutral', text: "Well, no time like the present to find out!" },
                { type: 'choice', options: [
                  { text: "Take the narrow path to the left", next: { chapter: 'chapter1', scene: 'hiddenPondScene', beat: 'discoveryBeat' }},
                  { text: "Follow the wider trail straight ahead", next: { chapter: 'chapter1', scene: 'ancientTreeScene', beat: 'firstSight' }}
                ]}
              ],
              next: null
            }
          }
        },
        hiddenPondScene: {
          location: 'hiddenPond',
          beats: {
            discoveryBeat: {
              lines: [
                { type: 'narration', text: "The narrow path opens up to reveal a serene pond, its surface like polished glass." },
                { type: 'dialog', speaker: 'oliver', variation: 'surprised', text: "Wow... I had no idea this was here!" },
                { type: 'narration', text: "The water reflects the sky perfectly, creating a mirror image of the clouds above." },
                { type: 'dialog', speaker: 'oliver', variation: 'happy', text: "This place is absolutely magical..." },
                { type: 'choice', options: [
                  { text: "Sit by the pond and reflect", next: { chapter: 'chapter1', scene: 'hiddenPondScene', beat: 'endingPeaceful' }},
                  { text: "Continue exploring", next: { chapter: 'chapter2', scene: 'mysteriousPath', beat: 'start' }}
                ]}
              ],
              next: null
            },
            endingPeaceful: {
              lines: [
                { type: 'narration', text: "Oliver finds peace by the tranquil waters, discovering that sometimes the greatest adventures are found in moments of quiet contemplation." },
                { type: 'dialog', speaker: 'oliver', variation: 'happy', text: "I think I'll come back here again..." }
              ],
              next: { isGameOver: true }
            }
          }
        },
        ancientTreeScene: {
          location: 'ancientTree',
          beats: {
            firstSight: {
              lines: [
                { type: 'narration', text: "Before Oliver stands an enormous tree, its trunk covered in mysterious carvings." },
                { type: 'dialog', speaker: 'oliver', variation: 'surprised', text: "These markings... they must be decades old!" },
                { type: 'narration', text: "The ancient bark seems to tell stories of times long past." },
                { type: 'dialog', speaker: 'oliver', variation: 'thinking', text: "I wonder who left these here..." },
                { type: 'choice', options: [
                  { text: "Study the carvings closely", next: { chapter: 'chapter2', scene: 'mysteriousPath', beat: 'start' }},
                  { text: "Head back to the trail", next: { chapter: 'chapter1', scene: 'ancientTreeScene', beat: 'ending' }}
                ]}
              ],
              next: null
            },
            ending: {
              lines: [
                { type: 'narration', text: "Sometimes the greatest wisdom comes from knowing when to turn back. Oliver leaves with a renewed appreciation for the forest's mysteries." },
                { type: 'dialog', speaker: 'oliver', variation: 'neutral', text: "There will always be more to discover another day." }
              ],
              next: { isGameOver: true }
            }
          }
        }
      }
    },
    chapter2: {
      scenes: {
        mysteriousPath: {
          location: 'forestClearing',
          beats: {
            start: {
              lines: [
                { type: 'narration', text: "The path leads Oliver to a sun-dappled clearing, where shafts of golden light pierce through the canopy." },
                { type: 'dialog', speaker: 'oliver', variation: 'happy', text: "This place feels magical!" },
                { type: 'narration', text: "Butterflies dance through the beams of light, leading deeper into the woods." },
                { type: 'dialog', speaker: 'oliver', variation: 'thinking', text: "Should I follow them?" },
                { type: 'choice', options: [
                  { text: "Follow the butterflies", next: { chapter: 'chapter2', scene: 'mysteriousPath', beat: 'magicalEnding' }},
                  { text: "Stay in the clearing", next: { chapter: 'chapter2', scene: 'mysteriousPath', beat: 'peacefulEnding' }}
                ]}
              ],
              next: null
            },
            magicalEnding: {
              lines: [
                { type: 'narration', text: "Following the butterflies, Oliver discovers a hidden world of natural wonders, each more beautiful than the last." },
                { type: 'dialog', speaker: 'oliver', variation: 'happy', text: "Sometimes the best adventures come from following your heart!" }
              ],
              next: { isGameOver: true }
            },
            peacefulEnding: {
              lines: [
                { type: 'narration', text: "Oliver spends time in the clearing, finding joy in the simple beauty of the moment." },
                { type: 'dialog', speaker: 'oliver', variation: 'happy', text: "Sometimes the real treasure is right where you are." }
              ],
              next: { isGameOver: true }
            }
          }
        }
      }
    }
  }
};
